import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Field } from "@/components/common";

const blank = { clan_name: "", tag: "", leader_name: "", members_count: "", discord: "", description: "", motivation: "" };

export function ClanApplicationForm() {
  const { user } = useAuth();
  const [f, setF] = useState(blank);
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  if (user === null) return null;
  if (!user) {
    return (
      <div className="nx-card p-6 md:p-8 border-[#962FFF]/30" data-testid="application-login-cta">
        <div className="eyebrow mb-2">Candida il tuo clan</div>
        <p className="text-sm text-[#C6C6CE]/80">Per inviare la candidatura accedi o crea un account: riceverai l'esito via email e nella tua area personale.</p>
        <div className="flex gap-2 mt-5"><Link to="/login" className="btn-primary btn-sm" data-testid="application-login-link">Accedi</Link><Link to="/registrazione" className="btn-ghost btn-sm">Registrati</Link></div>
      </div>
    );
  }
  if (user.email_verified === false) {
    return <div className="nx-card p-6 md:p-8 border-amber-400/30" data-testid="application-verify-required"><div className="eyebrow mb-2">Conferma la tua email</div><p className="text-sm text-[#C6C6CE]/80">Per candidare un clan devi prima confermare il tuo indirizzo email. Puoi richiedere un nuovo link dalla tua <Link to="/area" className="text-[#962FFF] hover:underline">area personale</Link>.</p></div>;
  }
  if (sent) {
    return <div className="nx-card p-6 md:p-8 border-emerald-400/30" data-testid="application-success"><div className="eyebrow mb-2">Candidatura inviata</div><p className="text-sm text-[#C6C6CE]/80">Lo staff valuterà la tua richiesta. Puoi seguirne lo stato dalla tua <Link to="/area" className="text-[#962FFF] hover:underline">area personale</Link>.</p></div>;
  }
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/clan-applications", { ...f, members_count: Number(f.members_count) });
      setSent(true);
      toast.success("Candidatura inviata");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form onSubmit={submit} className="nx-card p-6 md:p-10 space-y-4 border-[#962FFF]/30" data-testid="clan-application-form">
      <div><div className="eyebrow mb-2">Modulo di candidatura</div><h2 className="text-xl md:text-2xl font-bold uppercase text-[#F5F5F7]">Candida il tuo clan</h2></div>
      <div className="grid sm:grid-cols-2 gap-4">
        <Field label="Nome del clan"><input data-testid="application-name-input" required minLength={2} maxLength={60} className="nx-input" value={f.clan_name} onChange={set("clan_name")} /></Field>
        <Field label="Tag"><input data-testid="application-tag-input" required maxLength={10} className="nx-input uppercase" value={f.tag} onChange={set("tag")} /></Field>
        <Field label="Leader"><input data-testid="application-leader-input" required minLength={2} className="nx-input" value={f.leader_name} onChange={set("leader_name")} /></Field>
        <Field label="Numero di membri"><input data-testid="application-members-input" required type="number" min={1} max={500} className="nx-input" value={f.members_count} onChange={set("members_count")} /></Field>
        <Field label="Link Discord (opzionale)" className="sm:col-span-2"><input data-testid="application-discord-input" className="nx-input" value={f.discord} onChange={set("discord")} /></Field>
      </div>
      <Field label="Presentazione del clan (min. 20 caratteri)"><textarea data-testid="application-description-input" required minLength={20} rows={4} className="nx-input" value={f.description} onChange={set("description")} /></Field>
      <Field label="Perché volete entrare in NEXUM LEGACY? (min. 20 caratteri)"><textarea data-testid="application-motivation-input" required minLength={20} rows={4} className="nx-input" value={f.motivation} onChange={set("motivation")} /></Field>
      <button data-testid="application-submit" disabled={busy} className="btn-primary"><Send className="w-4 h-4" /> {busy ? "Invio..." : "Invia candidatura"}</button>
    </form>
  );
}
